import React from "react";
import CircleProgressBar from "./CircleProgressBar";
import CircleProgressBarMobile from "./CircleProgressBarMobile";

import { isMobile } from "react-device-detect";
import { ImgSkills } from "./StyledComponents/CircleProgressBarMobile.style";
import { ShowMore, ShowMoreSkills } from "./StyledComponents/ShowMore.style";
import ImgMobile from "./asset/pictures/simpleSuccess.svg";

import IllustrationCompetences from "./asset/pictures/Free_Illustrations/Analyse_Colour/analyse1.svg";

const MoreCompetences = () => {
  return (
    <>
      {isMobile ? (
        <ShowMoreSkills backgroundImg={ImgMobile}>
          <div className="circlesContentForMob">
            <div>
              <CircleProgressBarMobile title="Html & Css" target="67" />
              <CircleProgressBarMobile title="React" target="65" />
              <CircleProgressBarMobile title="NodeJS & Express" target="40" />
            </div>
            <div>
              <CircleProgressBarMobile title="Git" target="63" />
              <CircleProgressBarMobile title="Javascript" target="60" />
              <CircleProgressBarMobile title="Trello" target="70" />
            </div>
            <div>
              <CircleProgressBarMobile title="SQL" target="36" />
              <CircleProgressBarMobile title="Esprit d'équipe" target="100" />
              <CircleProgressBarMobile title="Bienveillante" target="100" />
            </div>
          </div>
        </ShowMoreSkills>
      ) : (
        <ShowMore>
          <div className="circlesContent">
            <div>
              <CircleProgressBar title="Html & Css" target="67" />
              <CircleProgressBar title="React" target="65" />
              <CircleProgressBar title="NodeJS & Express" target="40" />
            </div>
            <div>
              <CircleProgressBar title="Git" target="63" />
              <CircleProgressBar title="Javascript" target="60" />
              <CircleProgressBar title="Trello" target="70" />
            </div>
            <div>
              <CircleProgressBar title="SQL" target="36" />
              <CircleProgressBar title="Esprit d'équipe" target="100" />
              <CircleProgressBar title="Bienveillante" target="100" />
            </div>
            <ImgSkills
              className="imgCompetences"
              src={IllustrationCompetences}
              alt="pic's competences"
            />
          </div>
        </ShowMore>
      )}
    </>
  );
};

export default MoreCompetences;
